import { render, staticRenderFns } from "./ScheduleDetail.vue?vue&type=template&id=0a5528ff&scoped=true&"
import script from "./ScheduleDetail.vue?vue&type=script&lang=js&"
export * from "./ScheduleDetail.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleDetail.vue?vue&type=style&index=0&id=0a5528ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5528ff",
  null
  
)

export default component.exports